// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qKzG9y2wKMHisk {
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--ds-space-100, 8px);
}
.qKzG9y2wKMHisk.DiFYNcQKouJIlH {
  width: unset;
  padding: var(--ds-space-150, 12px) var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-150, 12px);
}
`, ""]);
// Exports
export var container = `qKzG9y2wKMHisk`;
export var panel = `DiFYNcQKouJIlH`;
export default ___CSS_LOADER_EXPORT___;
